;
define("product_list_deletion.tpl", function(){});

